// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XoftP","label":"styles_label__38Wts"};